<template>
  <div>
    <div class="base-margin__left-20">
      <p>{{ $t('customCluster.activity.networkInterfaceActivity.operation') }}</p>
      <p class="base-margin__bottom-5 base-margin__left-20">
        {{
          $t('customCluster.activity.networkInterfaceActivity.instanceAction', {
            instanceId: detailsDataInfo.instanceId,
            action: filterActivity(detailsDataInfo.activityType),
            count: detailsDataInfo.eventResourceCount,
            ids: detailsDataInfo.networkInterfaceIdList
          })
        }}
      </p>
      <div v-if="detailsDataInfo.activityStatus !== SubclusterActivityStatusRunning">
        <div class="base-margin__left-20">
          <p>{{ $t('customCluster.activity.networkInterfaceActivity.result') }}</p>
          <p class="base-margin__bottom-5">
            {{
              $t('customCluster.activity.networkInterfaceActivity.success', {
                action: filterActivity(detailsDataInfo.activityType),
                count: detailsDataInfo.successNumber
              })
            }}
            <span v-for="(item, index) in detailsDataInfo.successList" :key="index">，{{
                item.networkInterfaceId
              }}</span>
          </p>
          <p v-if="detailsDataInfo.errorMessage !== ''" class="base-margin__bottom-5 base-color__red">
            {{
              $t('customCluster.activity.networkInterfaceActivity.failed', {
                count: detailsDataInfo.errorNumber,
                action: filterActivity(detailsDataInfo.activityType)
              })
            }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="detailsDataInfo.errorMessage" class="base-margin__left-20">
      <p class="base-margin__bottom-5 base-color__red base-margin__left-20">
        {{
          $t('customCluster.activity.networkInterfaceActivity.reason', {
            action: filterActivity(detailsDataInfo.activityType),
            errorMessage: detailsDataInfo.errorMessage
          })
        }}
      </p>
    </div>
  </div>
</template>
<script>
import {
  SubclusterActivityStatusRunning,
  SubclusterActivityTypeAttachNetworkInterface,
  SubclusterActivityTypeDetachNetworkInterface
} from "@/common/constants";

export default {
  name: 'networkInterfaceActivity',
  props: {
    detailsData: Object,
  },
  data() {
    return {
      detailsDataInfo: {},
      SubclusterActivityStatusRunning
    };
  },

  mounted() {
    const successList = [];
    const errorList = [];
    const instanceId = this.detailsData.detailData[0].instanceId;
    this.detailsData.detailData.map((item) => {
      if (item.status === 3) {
        successList.push(item);
      }
      if (item.status === 4) {
        errorList.push(item);
      }
    });

    let networkInterfaceIdList = '';

    JSON.parse(this.detailsData.event).networkInterfaceIdList.map((item) => {
      networkInterfaceIdList += `${item} `;
    });

    this.detailsDataInfo = {
      ...this.detailsData,
      instanceId,
      successList,
      errorList,
      successNumber: successList.length,
      errorNumber: errorList.length,
      networkInterfaceIdList
    };
  },

  methods: {
    filterActivity(activityId) {
      switch (activityId) {
        case SubclusterActivityTypeAttachNetworkInterface:
          return this.$t('customCluster.activity.networkInterfaceActivity.attach');
        case SubclusterActivityTypeDetachNetworkInterface:
          return this.$t('customCluster.activity.networkInterfaceActivity.detach');
      }
    },
  },
};
</script>
